<template>
  <svg
    :width="width"
    :height="height"
    :viewBox="`0 0 ${width} ${height}`"
    class="inline-block align-middle"
    role="img"
    :aria-label="`sparkline of ${values.length} values`"
  >
    <polyline
      :points="points"
      fill="none"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle
      v-if="lastPoint"
      :cx="lastPoint.x"
      :cy="lastPoint.y"
      r="1.6"
      :fill="color"
    />
  </svg>
</template>

<script setup>
import { computed, defineProps } from 'vue'

const props = defineProps({
  values: { type: Array, default: () => [] },
  width: { type: Number, default: 90 },
  height: { type: Number, default: 22 },
  color: { type: String, default: '#3B82F6' },
})

function coordinates() {
  if (!props.values.length) return []
  const max = Math.max(...props.values, 1)
  const stepX = props.values.length > 1 ? props.width / (props.values.length - 1) : 0
  const pad = 2
  return props.values.map((v, i) => ({
    x: i * stepX,
    y: props.height - (v / max) * (props.height - pad * 2) - pad,
  }))
}

const points = computed(() =>
  coordinates().map(p => `${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(' '),
)

const lastPoint = computed(() => {
  const c = coordinates()
  return c.length ? c[c.length - 1] : null
})
</script>
